import {
  background,
  BackgroundProps,
  border,
  compose,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  space,
  SpaceProps,
  typography,
} from 'styled-system';
import { style } from '../utils/css';
import {
  BorderProps,
  color,
  ColorProps,
  ShadowProps,
  SolvCSSObject,
  TypographyProps,
} from './systemTypes';
import { SolvThemeType } from './theme';

/**
 * For any system component which should suppor the `as` prop
 */
export type PolymorphicComponent = {
  /** What element or component should used be used to render the base of this component */
  as?: React.ElementType;
};

/**
 * For any component that supports the sX props
 */
export type WithSx = {
  /** A css-in-js object which supports Jigsaw system keys and props */
  sx?: SolvCSSObject;
};

/**
 * This is the base set of system props all design system components should support
 */
export type SolvSystemProps = ColorProps<SolvThemeType> &
  TypographyProps<SolvThemeType> &
  SpaceProps<SolvThemeType> &
  LayoutProps<SolvThemeType> &
  FlexboxProps<SolvThemeType> &
  GridProps<SolvThemeType> &
  BackgroundProps<SolvThemeType> &
  BorderProps<SolvThemeType> &
  PositionProps<SolvThemeType> &
  ShadowProps<SolvThemeType>;

/** Base type for an exported component */
export type JigsawComponent<T = HTMLElement> = SolvSystemProps &
  WithSx &
  PolymorphicComponent &
  React.HTMLAttributes<T>;

/** Injects the SX prop from `props` */
export const sx = (props: WithSx) => style(props.sx ?? {});

/**
 * This value can be passed as an argument to styled-components `styled` function to add all of
 * the props we want.
 */
export const solvSystem = compose(
  color,
  typography,
  space,
  layout,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow,
);
